import { useTranslation } from "react-i18next"

// The new t() hook to handle text translation dynamically
const useTranslationSharie = () => {
  const { t } = useTranslation() // This comes from react-i18next

  return (text) => {
    return t(text) // Return translated text
  }
}

export default useTranslationSharie
